import { format } from 'date-fns';
import { Card } from '../../../design-system/components/Card';
import { useSessionConsent } from '../../consent/hooks';

interface ConsentBannerProps {
  meetingId: string;
}

export function ConsentBanner({ meetingId }: ConsentBannerProps) {
  const query = useSessionConsent(meetingId);
  if (query.isPending) return null;
  if (query.isError) return null;
  const log = query.data;

  if (log === null) {
    return (
      <Card className="ds-card dash-consent dash-consent--missing" role="status">
        Sem consentimento registrado para esta reunião.
      </Card>
    );
  }
  return (
    <Card className="ds-card dash-consent dash-consent--ok" role="status">
      Captura com consentimento registrado em{' '}
      {format(new Date(log.confirmed_at), 'dd/MM/yyyy HH:mm')}.
    </Card>
  );
}
